export default __webpack_public_path__ + "static/media/verify_green.19031895.svg";